module.exports = __webpack_public_path__ + "static/media/Zid 1.191709b6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Zid 1.jpg
// module id = 157
// module chunks = 0